// extracted by mini-css-extract-plugin
export default {"container":"PaletteOverlay_container__1loxA","group":"PaletteOverlay_group__+5yOD"};